import { render, staticRenderFns } from "./RegionToolbar.vue?vue&type=template&id=1aa370c8&scoped=true&"
import script from "./RegionToolbar.vue?vue&type=script&lang=js&"
export * from "./RegionToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RegionToolbar.vue?vue&type=style&index=0&id=1aa370c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa370c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins\\workspace\\Apps\\WebViewer\\Dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1aa370c8', component.options)
    } else {
      api.reload('1aa370c8', component.options)
    }
    module.hot.accept("./RegionToolbar.vue?vue&type=template&id=1aa370c8&scoped=true&", function () {
      api.rerender('1aa370c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\uScope\\js\\extensions\\annotations\\annotations-ui\\RegionToolbar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/annotations-ui/RegionToolbar.vue
// module id = 389
// module chunks = 0